import { render } from "./EnWidget.vue?vue&type=template&id=fcab943c&scoped=true"
import script from "./EnWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./EnWidget.vue?vue&type=script&setup=true&lang=js"

import "./EnWidget.vue?vue&type=style&index=0&id=fcab943c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcab943c"],['__file',"Shared/components/widgets/EnWidget/EnWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcab943c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcab943c', __exports__)) {
    api.reload('fcab943c', __exports__)
  }
  
  module.hot.accept("./EnWidget.vue?vue&type=template&id=fcab943c&scoped=true", () => {
    api.rerender('fcab943c', render)
  })

}


export default __exports__